import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {Box, Grid, Typography} from '@mui/material'
// import {type RootState} from 'redux/store'
import ShipmentStatus from './ShipmentStatus'
import ShipmentTable from './ShipmentTable'
import Binocular from 'assets/images/binocular.svg'
import AlertIcon from 'assets/images/alert-circle-outline-icon.svg'
import 'features/HomePage/TrackShipments/index.scss'
// import NoHistory from 'features/HomePage/TrackShipments/components/NoHistory'

const ShipmentData = () => {
    const [displayState, setDisplayState] = useState({
        dataExists: false,
        // nonParticipatingCarrier: false,
        exceptionCarrier: false,
        error: false,
        noResults: false
    })
    const {response: AWBResponse, error: errorResponse} = useSelector((state: any) => state.trackShipment)
    const [awbInfo, setAwbInfo] = useState({
        airlineCode: '',
        awbNumber: ''
    })

    useEffect(() => {
        const dataExistState =
            AWBResponse?.successFlag && Object.keys(AWBResponse?.exceptionCarrier).length === 0 && !errorResponse
        // Object.keys(AWBResponse?.nonParicipatingCarrier).length === 0
        // const nonParticipatingCarrierState =
        // AWBResponse?.successFlag &&
        // !errorResponse &&
        // Object.keys(AWBResponse?.nonParicipatingCarrier).length > 0
        const errorState = !AWBResponse?.successFlag && errorResponse
        const noResultState = !AWBResponse?.successFlag && !errorResponse
        const exceptionCarrierState =
            AWBResponse?.successFlag && Object.keys(AWBResponse?.exceptionCarrier).length > 0 && !errorResponse

        setDisplayState((prev) => ({
            ...prev,
            dataExists: !!dataExistState,
            exceptionCarrier: !!exceptionCarrierState,
            error: !!errorState,
            // nonParticipatingCarrier: !!nonParticipatingCarrierState,
            noResults: !!noResultState
        }))
        setAwbInfo((prev) => ({
            ...prev,
            airlineCode: AWBResponse?.airlineCode || '',
            awbNumber: AWBResponse?.awbNumber || ''
        }))
    }, [AWBResponse, errorResponse])

    return (
        <Box>
            {/* DATA EXISTS */}
            {displayState?.dataExists && (
                <Box>
                    <ShipmentStatus
                        currentStatus={AWBResponse?.currentStatus}
                        routingInfo={AWBResponse?.routingInfo}
                        unitInfo={AWBResponse?.unitInfo}
                    />
                    <ShipmentTable
                        shipmentHistory={AWBResponse?.shipmentHistory}
                        shipmentYear={AWBResponse?.shipmentYear}
                        weightUnit={AWBResponse?.unitInfo?.weightUnit}
                        routingInfo={AWBResponse?.routingInfo}
                        // partialCarrier={AWBResponse?.partialCarrier}
                    />
                </Box>
            )}
            {/* EXCEPTION CARRIER */}
            {displayState?.exceptionCarrier && (
                <ShipmentStatus
                    currentStatus={AWBResponse?.currentStatus}
                    routingInfo={AWBResponse?.routingInfo}
                    unitInfo={AWBResponse?.unitInfo}
                    exceptionCarrierInfo={AWBResponse?.exceptionCarrier}
                    awbInfo={awbInfo}
                />
            )}
            {/* NON PARTICIPATING CARRIER */}
            {/* {displayState?.nonParticipatingCarrier && (
                <NoHistory carrierDetails={AWBResponse?.nonParicipatingCarrier} />
            )} */}
            {/* NO RESULTS */}
            {displayState?.noResults && (
                <Grid container justifyContent='center' className='noresult-container'>
                    <Grid item xs={12} className='centered flex-col'>
                        <Typography className='noresult-bold-text'>No results found.</Typography>
                        <Typography>Please try another search.</Typography>
                        <Box className='noresult-img'>
                            <img src={Binocular} alt='icon' />
                        </Box>
                    </Grid>
                </Grid>
            )}
            {/* ERROR RESPONSE */}
            {displayState?.error && (
                <Grid container justifyContent='center' className='noresult-container'>
                    <Grid item xs={12} className='centered flex-col'>
                        <Typography className='noresult-bold-text'>
                            {errorResponse?.text} {errorResponse?.code?.length > 0 && <>({errorResponse?.code})</>}
                        </Typography>
                        <Typography>Please try again</Typography>
                        <Box className='noresult-img'>
                            <img src={AlertIcon} alt='icon' />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Box>
    )
}

export default ShipmentData
